import { Radio } from "antd";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { setErrorMessage } from "../store/actions/error.action";
import { useDispatch, useSelector } from "react-redux";
import {
  accountListSelector,
  selectedAccountSelector,
} from "../store/selectors/app.selector";
import { amountFormat } from "../services/common.service";

export default function AccountClassComponent({
  dataSource,
  onChange,
  selected,
  allMessages,
}) {
  const accountTypes = {
    CA: "Current Account",
    SA: "Saving Account",
  };
  
  const { t } = useTranslation();
  const [checkedValue, setCheckedValue] = useState(selected);
  const dispatch = useDispatch();
  const selectedAccount = useSelector(selectedAccountSelector);
  const accountList = useSelector(accountListSelector);

  const handleChange = useCallback(
    (e) => {
      setCheckedValue("");
      const allAccounts = Object.values(dataSource).flat();
      let selectedClass = allAccounts.find(
        (ele) => ele.accountClass === e.target.value
      );
      // const matchingAccount = accountList.filter(
      //   (account) => account.accountClass === e.target.value
      // );
      // if (matchingAccount.length > 0) {
      //   dispatch(
      //     setErrorMessage({
      //       data: { message: allMessages["similarAcctClassMsg"] },
      //     })
      //   );
      // } else if (
      //   parseFloat(selectedAccount.avlBalance) <
      //   parseFloat(selectedClass?.minimumBalance)
      // ) {
      //   dispatch(
      //     setErrorMessage({
      //       data: { message: allMessages["insufficientBalMsg"] },
      //     })
      //   );
      // } else {
      //   setCheckedValue(e.target.value);
      //   onChange(e);
      // }

      setCheckedValue(e.target.value);
      onChange(e);
    },
    [dataSource, selectedAccount]
  );

  return (
    <>
      <Radio.Group
        className="account-selection w-100"
        value={
          checkedValue !== undefined && checkedValue != null ? checkedValue : ""
        }
      >
        {Object.keys(dataSource).length > 0 && (
          <div className="row">
            {Object.entries(dataSource).map(([accountType, accounts]) => (
              <div>
                <h4 className="heading_color">{accountTypes[accountType]}</h4>
                <div className="col-12 mb-2">
                  {accounts.map((account, idx) => (
                    <Radio
                      value={
                        checkedValue === account.accountClass
                          ? checkedValue
                          : account.accountClass
                      }
                      className="acccard mb-2"
                      onChange={handleChange}
                      key={idx}
                    >
                      <span className="d-flex align-items-center justify-content-between spanhead account-class ">
                        {account.acctClassDescription}
                      </span>
                      <p className="accountClass-desc">{account.description}</p>
                    </Radio>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </Radio.Group>
    </>
  );
}
